export default __webpack_public_path__ + "static/media/fv_warehouse.aeef1360.svg";